import { AxiosService } from '../../axios/axios.service.ts';
import { tAutoRespondBulkResponse, tAutoRespondRequest, tAutoRespondResponse } from './AI.types.ts';
import { setSlbChatMapping, clearSlbChatMap } from '../../pages/Pipe/slbChatMap.ts';

export const autoRespondService = {
  getState: async function (
    workspaceId: string,
    chatId: string,
  ): Promise<tAutoRespondResponse> {
    return AxiosService.get<tAutoRespondResponse>(
      `/ai/workspaces/${workspaceId}/chats/${chatId}/auto-respond`,
      { isLegacy: false },
    );
  },

  getBulkState: async function (
    workspaceId: string,
    leadIds: string[],
  ): Promise<tAutoRespondBulkResponse> {
    const response = await AxiosService.get<tAutoRespondBulkResponse>(
      `ai/workspaces/${workspaceId}/auto-respond/bulk?leadIds=${leadIds.join(',')}`,
      { isBFFService: true },
    );
    // Normalize: BFF wraps in { states: [...] }, raw array from chatbot-service needs wrapping
    const normalized = Array.isArray(response)
      ? { states: response as unknown as tAutoRespondBulkResponse['states'] }
      : response;
    // Populate the SLB chat map so the pipe kanban can open the correct chat
    clearSlbChatMap();
    for (const s of normalized.states) {
      if (s.enabled && s.chatId && s.channelType) {
        setSlbChatMapping(s.leadId, { chatId: s.chatId, channelType: s.channelType });
      }
    }
    return normalized;
  },

  toggle: async function (
    chatId: string,
    request: tAutoRespondRequest,
  ): Promise<tAutoRespondResponse> {
    try {
      const response = await AxiosService.patch<
        tAutoRespondRequest,
        tAutoRespondResponse
      >(`/ai/workspaces/${request.workspaceId}/chats/${chatId}/auto-respond`, request, {
        isLegacy: false,
      });

      return Promise.resolve(response);
    } catch (error) {
      console.error('Error toggling auto-respond:', error);
      return Promise.reject(error);
    }
  },
};
